import { get, patch, post } from '../../utils/http';

export const getBilling = ({ type, date }) => get(`/billing`, { period: { type, date } });

export const createBilling = ({ body }) => post(`/billing`, body);

export const updateBilling = ({ accountId, ...payload }) => patch(`/billing/${accountId}`, { ...payload });

export const getBillingHistory = ({ type, date }) => get(`/billing/history`, { period: { type, date } });
